import { FunctionComponent } from 'react';
import { TSCard } from './shared/card/Card';

interface NoDataCardProps {
  message: string;
}

const NoDataCard: FunctionComponent<NoDataCardProps> = ({ message }) => {
  return <TSCard className="font-semibold flex justify-center p-6">{message}</TSCard>;
};

export default NoDataCard;
